import { render, staticRenderFns } from "./PlainLayoutWhite.vue?vue&type=template&id=350396f1&scoped=true"
import script from "./PlainLayoutWhite.vue?vue&type=script&lang=js"
export * from "./PlainLayoutWhite.vue?vue&type=script&lang=js"
import style0 from "./PlainLayoutWhite.vue?vue&type=style&index=0&id=350396f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350396f1",
  null
  
)

export default component.exports